module.exports = __webpack_public_path__ + "img/pro_ten_1.5fba45bd.jpg";